// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3PMR0","iconSpacer":"_1Ujlp","input":"_3VXEd"};